// composables/useDarkMode.ts
import { ref, onMounted, watch } from 'vue'
import { lsGet, lsSet } from '@/utils/storage'

export function useDarkMode() {
  const isDark = ref(false)

  const setTheme = (dark: boolean) => {
    const html = document.documentElement
    if (dark) {
      html.classList.add('dark')
      html.setAttribute('data-theme', 'dark')
    } else {
      html.classList.remove('dark')
      html.setAttribute('data-theme', 'light')
    }
  }

  const toggleDark = () => {
    isDark.value = !isDark.value
  }

  onMounted(() => {
    const saved = lsGet('theme')
    if (saved) {
      isDark.value = saved === 'dark'
    } else {
      isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches
    }
    setTheme(isDark.value)
  })

  watch(isDark, (val) => {
    setTheme(val)
    lsSet('theme', val ? 'dark' : 'light')
  })

  return { isDark, toggleDark }
}
